;(function () {
  angular.module('app').constant('searchTypes', {
    org: {
      apps: 'APPLICATIONS',
      servers: 'SERVERS',
      libs: 'LIBRARIES',
      vulns: 'VULNERABILITIES',
      threats: 'THREATS'
    },
    superadmin: {
      orgs: 'ORGANIZATIONS',
      apps: 'APPLICATIONS',
      servers: 'SERVERS',
      vulns: 'VULNERABILITIES',
      groups: 'GROUPS',
      users: 'USERS'
    }
  })
})()
